import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const CreateInfluencerSocialMedia = (
  userId: string,
  data: {
    [key: string]: string | number | boolean | null
  },
) => {
  return apiInstance.post(ApiPathConfig.INFLUENCER_SOCIAL_MEDIA(userId), data)
}

export default CreateInfluencerSocialMedia
